function toggle(selector) {
    const togglerObjects = document.querySelectorAll(selector)
    if (togglerObjects?.length > 0) {
        togglerObjects.forEach(togglerObject => {
            let visibleHiddenObject = togglerObject?.nextElementSibling
            if (visibleHiddenObject) {
                togglerObject.addEventListener('click', function () {
                    visibleHiddenObject.style.display = visibleHiddenObject.style.display === 'flex' ? '' : 'flex'
                    togglerObject.classList.toggle('rotate')
                })
                document.addEventListener('click', (e) => {
                    if (!togglerObject.contains(e.target) && !visibleHiddenObject.contains(e.target)) {
                        visibleHiddenObject.style.display = ''
                        togglerObject.classList.remove('rotate')
                    }
                })
            }
        })
    }
}

document.addEventListener('DOMContentLoaded', () => toggle('.toggler, .menu-item-has-children > *:not(ul)'))


function addToMobileMenu() {
    const headerMobileAdditional = document.querySelector(`${headerMenuClass}__mobile-addition`)
    if (headerMobileAdditional) {
        const menus = document.querySelectorAll(`${sidebarClass} .nav`)
        if (menus.length > 0) {
            menus.forEach(menu => {
                const clonedMenu = menu.cloneNode(true)
                headerMobileAdditional.appendChild(clonedMenu)
            })
            setTimeout(() => {
                toggle(`${headerMenuClass} .menu-item-has-children > *:not(ul)`)
            }, 100)
        }
    }
}

function toggleHeaderMenu() {
    if (typeof headerMenuClass !== 'undefined') {
        const headerMenuTogglerButton = document.querySelector(`${headerMenuClass} button`)
        if (headerMenuTogglerButton) {
            let clicked = false
            headerMenuTogglerButton.addEventListener('click', function () {
                headerMenuTogglerButton.classList.toggle('toggled')
                if (!clicked) {
                    addToMobileMenu()
                    clicked = true
                }
            })
        }
    }
}

document.addEventListener('DOMContentLoaded', () => toggleHeaderMenu())
